export const AUTH_REQUEST = "AUTH_REQUEST";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_ERROR = "AUTH_ERROR";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTH_PASSWORD_FORGET = "AUTH_PASSWORD_FORGET";
export const AUTH_PASSWORD_RESET = "AUTH_PASSWORD_RESET";
